import React from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { calendar_url, protected_api_call } from '../api/api';



moment.locale("en");
const localizer = momentLocalizer(moment);


class ReactBigCalendar extends React.Component {

    state = {
        eventsData: []
    }

    componentDidMount = async () => {
        let p = ["Vupalli", "Gandra", "Patel", "Doc 4", "Doc 5", "NP 1", "NP 2", "NP 3", "NP 4"]
        let resp = await this.get_all_events();

        if(resp.status === 200){
            let data = await resp.json();

            const { pastMonthDates, currentMonthDates } = this.getDatesInPastMonthAndCurrentMonth();
            let a = []
            pastMonthDates.forEach(date => {
                let temp_date = date.toISOString().split('T')[0];
                p.forEach(e => {
                    let exists = data["data"][temp_date] && data["data"][temp_date].includes(e)
                    a.push({done:!exists, start: date, end: date, title: e});
                })
            });
            currentMonthDates.forEach(date => {
                let temp_date = date.toISOString().split('T')[0];
                p.forEach(e => {
                    let exists = data["data"][temp_date] && data["data"][temp_date].includes(e)
                    a.push({done:!exists, start: date, end: date, title: e});
                })
            });
            this.setState({
                eventsData: a
            })
        }else{
            alert("Cannot connect to server")
        }
    }


    style_event = (e, s, en) => {
        var style = {}
        if(e.done === false){
            style = {
                backgroundColor: '#aa2626',
                borderRadius: '10px',
                opacity: 0.6,
                color: '#ffffff',
                border: '1px',
                display: 'block',
                width: '95%'
            };
        }else{
            style = {
                backgroundColor: '#2626aa',
                borderRadius: '10px',
                opacity: 0.6,
                color: '#ffffff',
                border: '1px',
                display: 'block',
                width: '95%'
            }
        }
        return {
            style: style
        };
    }

    send_calendar_update = async (event, title) => {
        let date = event.start;
        // convert date to string
        date = date.toISOString().split('T')[0];
        let resp = await protected_api_call(calendar_url, {"date": date, "doctor": title});
        return resp
    }

    get_all_events = async () => {
        let resp = await protected_api_call(calendar_url, {}, "GET");
        return resp
    }

    handleEventSelect = async (event) => {
        var events = this.state.eventsData;
        var index = events.indexOf(event);
        let title = events[index].title
        events[index].title = "Updating ... "
        this.setState({eventsData: events})

        let resp = await this.send_calendar_update(event, title);
        if(resp.status === 201 || resp.status === 204){
            events[index].done = !events[index].done;
        }else{
            alert("Error")
        }

        events[index].title = title
        this.setState({
            eventsData: events
        })
    }

    getDatesInPastMonthAndCurrentMonth = () => {
        const today = new Date();
        let currentMonthDates = [];
        let pastMonthDates = [];
    
        // Get all dates of the current month until today
        for (let day = 1; day <= today.getDate(); day++) {
            currentMonthDates.push(new Date(today.getFullYear(), today.getMonth(), day));
        }
    
        // Get all dates of the past month
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthDays = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    
        for (let day = 1; day <= lastMonthDays; day++) {
            pastMonthDates.push(new Date(lastMonth.getFullYear(), lastMonth.getMonth(), day));
        }
    
        return { pastMonthDates, currentMonthDates };
    }


    render(){
        

        return (
            <div className="App">
                <Calendar
                    views={["work_week", "month"]}
                    selectable
                    localizer={localizer}
                    defaultDate={new Date()}
                    defaultView="month"
                    events={this.state.eventsData}
                    style={{ height: "90vh" }}
                    onSelectEvent={this.handleEventSelect}
                    // onSelectSlot={}
                    eventPropGetter={this.style_event}
                    showAllEvents={true}
                />
            </div>
        )
    }
}

class CalendarComp extends React.Component {
    render(){
        return (
            <div>
                <ReactBigCalendar />
            </div>
        )
    }
}

export default CalendarComp;